import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserAttribute,
  CognitoUserPool,
} from 'amazon-cognito-identity-js';
import { Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoginService } from 'src/app/services/login-service/login.service';
import { ResourceCenterModalComponent } from '../../../components/resource-center-modal/resource-center-modal.component';

@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss'],
})
export class CreatePasswordComponent implements OnInit {
  @Output() nextStep = new EventEmitter<number>();
  @Input() email = '';
  loading = false;

  frmCreatePassword = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      Validators.pattern(
        '(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])|(?=.*[a-z])(?=.*[0-9])(?=.*[$%&!@*#?_-])|(?=.*[A-Z])(?=.*[0-9])(?=.*[$%&!@*#?_-])|(?=.*[A-Z])(?=.*[a-z])(?=.*[$%&!@*#?_-])).{13,}$'
      ),
    ]),
    confirmPassword: new FormControl('', [
      Validators.required,
      Validators.pattern(
        '(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])|(?=.*[a-z])(?=.*[0-9])(?=.*[$%&!@*#?_-])|(?=.*[A-Z])(?=.*[0-9])(?=.*[$%&!@*#?_-])|(?=.*[A-Z])(?=.*[a-z])(?=.*[$%&!@*#?_-])).{13,}$'
      ),
    ]),
    termsCondition: new FormControl(false, Validators.required),
  });

  toolTip: string;
  captcha_token = '';

  constructor(
    public loginService: LoginService,
    private router: Router,
    private dialogRef: DynamicDialogRef,
    private dialogService: DialogService
  ) {
    this.toolTip = this.getTooltipContent();
  }

  ngOnInit(): void {}

  getTooltipContent() {
    return `
              <h6>password requirements</h6>
              <ul>
                <li>Must contain at least 13 characters</li>
                <li>Must contain at least 3 of the following:
                  <ul>
                    <li>An uppercase character</li>
                    <li>A lowercase character</li>
                    <li>A number</li>
                    <li>A special character</li>
                  </ul>
                </li>
              </ul>
    `;
  }

  confirm() {
    // TODO => I should expect email and token to make sure its a correct link
    this.loading = true;
    const userPool = this.loginService.getCognitoUserPool();

    const attributeList = [];
    const attrData = {
      Name: 'email',
      Value: this.email.toLowerCase(),
    };

    const attribute = new CognitoUserAttribute(attrData);
    attributeList.push(attribute);

    userPool.signUp(
      this.email.toLowerCase(),
      this.frmCreatePassword.value.password,
      attributeList,
      [],
      (err, result) => {
        if (err) {
          this.loading = false;
          return;
        }
        this.authenticateUser(userPool);
      }
    );
  }

  resetCaptcha() {
    this.captcha_token = '';
  }

  showResponse(event: any) {
    this.captcha_token = event.response;
  }

  authenticateUser(userPool: CognitoUserPool) {
    const cognitoUser = new CognitoUser({
      Username: this.email.toLowerCase(),
      Pool: userPool,
    });
    //cognitoUser.confirmRegistration('268110', false, ()=>{});
    cognitoUser.authenticateUser(
      new AuthenticationDetails({
        Username: this.email.toLowerCase(),
        Password: this.frmCreatePassword.value.password,
      }),
      {
        onSuccess: (res) => {
          this.authenticateOnSuccess();
        },
        onFailure: (err) => {
          this.loading = false;
        },
      }
    );
  }

  authenticateOnSuccess() {
    this.loginService.getUser()?.subscribe({
      next: (response: any) => {
        this.loginService.setUser(response[0].json_build_object);
        this.router.navigate(['/']);
        this.dialogRef.close();
        this.loading = false;
        setTimeout(() => {
          this.openDia();
        }, 500);
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  openDia() {
    this.dialogService.open(ResourceCenterModalComponent, {
      width: '980px',
      height: '700px',
      showHeader: false,
      closeOnEscape: true,
    });
  }
}
